module.exports = __webpack_public_path__ + "static/media/ev8.1ff06be7.jpg";